import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import React from "react";
import {
    VideoSlidesSoundIconBox
} from "./boxes/video-slides-sound-icon.box";

import {SvgSizeUnit} from "../../../../basic-ui-components/icon/svg-icon/svg.icon";

export const VideoSlidesSoundButtonComponent: React.FC<{}> = observer(() => {
    const services = useServices();
    const sound = services.user.preferences.sound;

    const SoundOnIcon = services.theme.currentTheme.icons.soundOnIcon;
    const SoundOffIcon = services.theme.currentTheme.icons.soundOffIcon;

    const handleClick = () => {
        sound.toggle();
    };

    return (
        <VideoSlidesSoundIconBox onClick={handleClick}>
            {sound.isMuted ? <SoundOffIcon sizeUnit={SvgSizeUnit.Px} size={22} /> : <SoundOnIcon sizeUnit={SvgSizeUnit.Px} size={22} />}
        </VideoSlidesSoundIconBox>
    )
});
